import sellerStore from 'store/indexSeller';
import Cookie from 'js-cookie';
import {SELLER_APP_AUTH_TOKEN_KEY, SELLER_ACCOUNT_ID_KEY} from 'utils/api/cookieUtils';

export function redirectSellerToTR () {
  Cookie.remove(SELLER_APP_AUTH_TOKEN_KEY);
  Cookie.remove(SELLER_ACCOUNT_ID_KEY);
  window.location.href = sellerStore.getters['sellerCommon/baseTochkaRedirectUrl'];
}
